<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
    <h2>{{'INDICATOR-SECTOR.TITLE' | translate}}</h2>
    <!-- <ntr-add-button [openView]="'indicator-sector-add-edit'"></ntr-add-button> -->

    <ntr-datatable [data]="data" [metaInfo]="metaInfo" [actionButtons]="false"  [entityTitle]="'indicatorSector'" [modelView]="'indicator-sector-add-edit'" [disableHeader]="false" (onQuery)="onGridQuery($event)" [columns]="columns" [headers]="['name','description']" (onDeleteQuery)="deleteIndicatorSector($event)"></ntr-datatable>
</div>